import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Visibility from "@material-ui/icons/Visibility";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import ActivateIcon from "@material-ui/icons/CheckCircle";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { useInactivity } from "components/Inactivity/Inactivity";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import CustomModal from "components/CustomModal/Modal.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import { sendEmailAgent, statusCustomerUser } from "views/Services/ClientService";

import { Tooltip } from "@material-ui/core";

import {
  checkIfIsKiosko,
  sanatizeMessageHtml,
} from "components/Utils/utils.js";
import environment from "../../environment/environment";
import { useTranslation } from "react-i18next";
import { getCustomersList } from "views/Services/ClientService";
const server = `${environment.SERVER}`;

const useStyles = makeStyles(styles);
const useStylesPrincipal = makeStyles(stylePrincipal);
export default function Dashboard() {
  const wizardRef = useRef(null);
  const { t, i18n } = useTranslation();
  const classesPrincipal = useStylesPrincipal();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const isKiosko = checkIfIsKiosko();
  const history = useHistory();
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [clients, setClients] = useState([]);
  const isInactive = useInactivity();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const [totalRows, setTotalRows] = useState(0);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [isAgent, setIsAgent] = useState(false);
  const [allClients, setAllClients] = useState("my");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [isOpenErrors, setIsOpenErrors] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [currentOrderId, setCurrentOrderId] = useState(0);
  const [currentName, setCurrentName] = useState("");
  const [csrEmail, setCsrEmail] = useState("");
  const [loading, setLoading] = React.useState(false);
  const rowsForPage = 10;

  useEffect(() => {
    let searchClient = "";
    if (localStorage.getItem("searchClients")) {
      setSearch(localStorage.getItem("searchClients"));
      searchClient = localStorage.getItem("searchClients");
    }
    getClients(currentOffset, searchClient);
  }, [dispatch, isAgent, allClients]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setClients([]);
      handleChangePage(0);
      goToFirstPage();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const tableRef = useRef();

  const goToFirstPage = () => {
    tableRef.current.resetPage(0);
  };

  const goNext = () => {
    tableRef.current.nextPage();
  };

  const getClients = async (offset, searchClients) => {
    setLoading(true);
    let searchCustomer = searchClients ? searchClients : search;
    let data = {
      draw: "1",
      option: allClients,
      columns: {
        0: {
          data: "client_number",
          name: "",
          searchable: "true",
          orderable: "true",
          search: {
            value: "",
            regex: "false",
          },
        },
      },
      order: {
        0: {
          column: "0",
          dir: "asc",
        },
      },
      start: offset,
      length: 100,
      search: {
        value: searchCustomer,
        regex: "false",
      },
      token: localStorage.getItem("userToken"),
    };

    const resultSubmit = await dispatch(getCustomersList(data));
    setClients(resultSubmit.payload.data.data);
    setTotalRows(resultSubmit.payload.data.recordsTotal);
    setCurrentOffset(offset);
    setLoading(false);
  };

  const updateStatusUser = async (userId, status) => {
    let data = {
      userId: userId,
      status: status,
    };

    const resultSubmit = await dispatch(statusCustomerUser(data));
    if (resultSubmit.payload.result) {
      getClients(currentOffset);
    } else {
      setMessageToast(resultSubmit.payload.message);
      setIsOpenErrors(true);
    }
  };

  const closeModal = () => {
    setIsOpenErrors(false);
    setCurrentName("");
    setCurrentOrderId(0);
    setCsrEmail("");
    setEmail("");
  };

  const sendEmail = async () => {
    const data = {
      orderid: currentOrderId,
      email: email,
      csr_email: csrEmail,
      uri: "/guest/summary/" + currentOrderId,
      to_name: currentName,
    };

    const resultSubmit = await dispatch(sendEmailAgent(data));
    setMessageToast(resultSubmit.payload.message);
    console.log(resultSubmit.payload.result);
    if (resultSubmit.payload.result) {
      closeModal();
      setModalSuccess(true);
    }
  };

  const setMyPolicies = () => {
    setAllPolicies(false);
    setIsAgent(true);
  };
  const setPolicies = () => {
    setAllPolicies(false);
    setIsAgent(false);
  };
  const setAllYearsMyPolicies = () => {
    setAllPolicies(true);
    setIsAgent(true);
  };
  const setAllYearsAllPolicies = () => {
    setAllPolicies(true);
    setIsAgent(false);
  };
  const classes = useStyles();

  // Hooks
  const redesign = process.env.REACT_APP_REDESIGN;
  const isRedesign = redesign === "true" ? true : false;
  const url = redesign === "true" ? "/guestRedesing" : "/admin/wizard";

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name === "search") {
      setSearch(value);
      localStorage.setItem("searchClients", value);
    }
    if (name === "email") {
      setSearch(value);
    }
    if (name === "csr") {
      setCsrEmail(value);
    }
  };

  const fillButtons = (order) => {
    const styleButton = {
      cursor: "pointer",
      padding: "0px !important",
    };
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() => history.push(`/admin/client/${order.client_number}`)}
            md={2}
            style={styleButton}
          >
            <Tooltip title="View Client" placement="top" arrow>
              <Visibility
                style={{ color: "#13816F" }}
                fontSize="small"
              ></Visibility>
            </Tooltip>
          </GridItem>
          {["1", "2", "3"].includes(order.activated) ? (
            <GridItem
              onClick={() => {
                updateStatusUser(order.user_id, 0);
              }}
              md={2}
              style={styleButton}
            >
              <Tooltip title="Disable Customer" placement="top" arrow>
                <CheckIcon
                  style={{ color: "#13816F" }}
                  fontSize="small"
                ></CheckIcon>
              </Tooltip>
            </GridItem>
          ) : (
            <GridItem
              onClick={() => {
                updateStatusUser(order.user_id, 1);
              }}
              md={2}
              style={styleButton}
            >
              <Tooltip title="Enable Customer" placement="top" arrow>
                <CloseIcon
                  style={{ color: "#13816F" }}
                  fontSize="small"
                ></CloseIcon>
              </Tooltip>
            </GridItem>
          )}
          {["2", "3"].includes(order.activated) ? (
            <GridItem
              onClick={() => {
                updateStatusUser(order.user_id, 1);
              }}
              md={2}
              style={styleButton}
            >
              <Tooltip
                title={order.activated === "2" ? "Unblock" : "Activate"}
                placement="top"
                arrow
              >
                <ActivateIcon
                  style={{ color: "#13816F" }}
                  fontSize="small"
                ></ActivateIcon>
              </Tooltip>
            </GridItem>
          ) : null}
        </GridContainer>
      </>
    );
  };
  const handleChangePage = (currentPage) => {
    if ((currentPage * rowsForPage) % 100 === 0) {
      getClients(currentPage * rowsForPage);
    }
  };

  const getActiveClients = () => {
    let clientsT = [];
    let daysLeft = 0;
    clients.forEach((order, index) => {
      const rowIndex = currentOffset + index + 1;
      clientsT[rowIndex] = [
        order.client_number,
        {
          name: order.customer_name,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.address,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.city,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.state,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.phone,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.email,
          className: isXs || isSm ? classes.displayNone : "",
        },
        order.dl_number,
        fillButtons(order),
      ];
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                ref={tableRef}
                tableHead={[
                  t("clients.clientNumber"),
                  {
                    name: t("clients.clientName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("clients.address"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("clients.city"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("clients.state"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("clients.phone"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("clients.email"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  t("clients.driverLicense"),
                  t("clients.options"),
                ]}
                tableData={clientsT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
                rowsPerPage={10}
                totalRows={totalRows}
                changePage={handleChangePage}
                loading={loading}
              />

              <CustomModal
                title="Send Email"
                isOpen={isOpenErrors}
                onClose={closeModal}
                privacy={false}
                id={"emailModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <p style={{ color: "red" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sanatizeMessageHtml(messageToast),
                        }}
                      ></div>
                    </p>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={1}></GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step2.email")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "email",
                        id: "email",
                        value: email,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step4.csrInitials")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "csr",
                        id: "csr",
                        value: csrEmail,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="sendEmail"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            sendEmail();
                          }}
                          block
                        >
                          Send
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
              <CustomModal
                title="Success"
                isOpen={modalSuccess}
                onClose={() => {
                  setModalSuccess(false);
                  setMessageToast("");
                }}
                privacy={false}
                id={"successModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <h4>{messageToast}</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="successButton"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            setModalSuccess(false);
                            setMessageToast("");
                          }}
                          block
                        >
                          Ok
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };

  const Clients = () => {
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "20px 0px 40px 0px" }}
              justify="center"
            >
              <GridContainer>
                <GridItem xs={12} md={12}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("clients.title")}{" "}
                        </div>
                        <GridContainer>
                          {clients && (
                            <>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                <GridContainer>
                                  <GridItem xs={0} sm={0} md={3}></GridItem>

                                  <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                      id="continueMobile"
                                      onClick={() => setAllClients("all")}
                                      style={{ backgroundColor: "#008670" }}
                                      block
                                    >
                                      {t("clients.buttons.allClients")}
                                    </Button>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                      id="continueMobile"
                                      onClick={() => setAllClients("my")}
                                      style={{ backgroundColor: "#008670" }}
                                      block
                                    >
                                      {t("clients.buttons.myClients")}
                                    </Button>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                      id="continueMobile"
                                      onClick={() =>
                                        (window.location.href = `/admin/client`)
                                      }
                                      style={{ backgroundColor: "#008670" }}
                                      block
                                    >
                                      {t("clients.buttons.addClient")}
                                    </Button>
                                  </GridItem>
                                </GridContainer>
                              </GridItem>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                <GridContainer>
                                  <GridItem xs={0} sm={0} md={9}></GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <CustomInput
                                      labelText={t("step2.search")}
                                      formControlProps={{
                                        fullWidth: true,
                                        className:
                                          classes.customFormControlClasses,
                                      }}
                                      inputProps={{
                                        name: "search",
                                        id: "search",
                                        value: search,
                                        onChange: handleFormChange,
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                              </GridItem>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                {getActiveClients()}
                              </GridItem>
                            </>
                          )}
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  return <>{Clients()}</>;
}
